import DPIAComponent from './DPIA';
import ListDPIAComponent from './ListDPIA';
import { DpiaProvider } from './dpia.context';

export function DPIA() {
    return (
        <DpiaProvider>
            <DPIAComponent />
        </DpiaProvider>
    );
}

export function ListDPIA() {
    return (
        <DpiaProvider>
            <ListDPIAComponent />
        </DpiaProvider>
    );
}
